import { Button, Card, Col, Flex, Row, Space, theme } from 'antd';
import { FC } from 'react';
import { HiddenPassword } from '../../../../../../../../common/components';

interface Props {
  url: string;
  password: string;
  handleOpenOAuthWindow: (url: string) => void;
  handleBack: () => void;
}

export const ThirdStepView: FC<Props> = ({ url, password, handleOpenOAuthWindow, handleBack }) => {
  const { token } = theme.useToken();

  return (
    <Row gutter={ [0, 16] }>
      <Col span={ 24 }>
        <Card style={{ backgroundColor: token.colorBgLayout, outline: `2px dashed ${ token.colorBorder }`, outlineOffset: -8 }}>
          <Flex align="center" justify="center" wrap="wrap" vertical gap={ 8 } style={{ textAlign: 'center' }}>
            <span>
              Відкрийте вікно <b>OAuth2</b> та увійдіть в цей акаунт Google за допомогою паролю:&#20;
            </span>
            <span><HiddenPassword password={ password }/></span>
          </Flex>
        </Card>
      </Col>

      <Col span={ 24 }>
        <Space direction="vertical" className="ant-space-fullwidth">
          <Button
            shape="round"
            type="primary"
            block
            onClick={ () => handleOpenOAuthWindow(url) }
          >
            Відкрити вікно OAuth2
          </Button>
          <Button
            block
            onClick={ handleBack }
          >
            Пізніше
          </Button>
        </Space>
      </Col>
    </Row>
  );
};
